module.exports = __webpack_public_path__ + "static/media/sredstva_it.65e1e17f.pdf";